import { render } from "./QuickLaunchWidget.vue?vue&type=template&id=4624a452&scoped=true"
import script from "./QuickLaunchWidget.vue?vue&type=script&lang=js"
export * from "./QuickLaunchWidget.vue?vue&type=script&lang=js"

import "./quick-launch-widget.scss?vue&type=style&index=0&id=4624a452&lang=scss&scoped=true"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4624a452"]])

export default __exports__